import { useMemo, useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import JsLoading from '@/components/js-loading';
import InjectedCMS from '@/components/injected-cms';
import ProviderCrumb from '@/components/outest-layout/provider-crumb';
import { useQueryHeader } from '@/apis/platform/header';

export default function CmsGlobal(props) {
  const { channelId } = useParams();
  const { updateCrumbs } = useContext(ProviderCrumb);

  const channelHeadQuery = useMemo(() => {
    if (!channelId) return undefined;
    else return { channelId };
  }, [channelId]);

  const [{ data: channelHeadInfo, loading }] = useQueryHeader(channelHeadQuery);

  useEffect(() => {
    if (!channelHeadInfo) return;

    updateCrumbs([
      { title: '首页', link: '/' },
      // 怎么确认是哪个？
      { title: '平台营销阵地', link: '/platform-marketing' },
      { title: channelHeadInfo.channelName, link: `/platform-marketing/${channelHeadInfo.channelId}` },
      { title: props.title, link: '' },
    ]);
    // eslint-disable-next-line
  }, [channelHeadInfo, updateCrumbs]);

  if (loading || !channelHeadInfo) return <JsLoading />;

  return <InjectedCMS url={props.url} injectType={props.injectType} microName="CmsGlobal" />;
}
